<template>

  <vuestic-widget header-text="403!!!!">
    <div class="container">
      <h1 class="container--title">403 - NO TIENE ACCESO</h1>
      <img src="" alt="">
    </div>
  </vuestic-widget>


<!--  <div class="not-found-pages va-row">-->


<!--    <div class="flex md12">-->
<!--      <div class="va-row">-->
<!--        <vuestic-card-->
<!--          class="not-found-pages__cards"-->
<!--          :image="item.imageUrl"-->
<!--          v-for="item in items"-->
<!--          :key="item.$index"-->
<!--        >-->
<!--          {{ item.label }}-->
<!--          <div class="not-found-pages__button-container pt-3 mb-0">-->
<!--            <router-link-->
<!--              :to="{ name: item.buttonTo }"-->
<!--              target="_blank"-->
<!--            >-->
<!--              <button-->
<!--                class="btn btn-primary btn-sm not-found-pages__advanced-button">-->
<!--                {{ 'View Example' }}-->
<!--              </button>-->
<!--            </router-link>-->
<!--          </div>-->
<!--        </vuestic-card>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</template>
<script>

import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
export default {
  name: 'not-found-pages',
  components: {VuesticWidget},
  data () {
    return {
      items: [
        {
          imageUrl: 'https://i.imgur.com/GzUR0Wz.png',
          label: 'Advanced layout',
          buttonTo: 'not-found-advanced',
        },
        {
          imageUrl: 'https://i.imgur.com/HttcXPi.png',
          label: 'Simple',
          buttonTo: 'not-found-simple',
        },
        {
          imageUrl: 'https://i.imgur.com/dlcZMiG.png',
          label: 'Custom image',
          buttonTo: 'not-found-custom',
        },
        {
          imageUrl: 'https://i.imgur.com/qcOlDz7.png',
          label: 'Large text heading',
          buttonTo: 'not-found-large-text',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.not-found-pages {
  $cardGutter: #{(19/16)}rem;
  .vuestic-card.not-found-pages__cards {
    min-width: 220px;
    text-align: center;
    margin: 0 $cardGutter calc(#{$cardGutter} * 2) $cardGutter;
  }
  &__button-container {
    .btn.not-found-pages__advanced-button {
      font-size: $font-size-root;
      font-weight: $font-weight-bold;
      padding-left: 0;
      padding-right: 0;
      width: 180px;
    }
    text-align: center;
  }
}
.container{
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  .container--title{
    grid-column: 2/3;
    font-family: 'Open Sans', 'Source Sans Pro', 'Helvetica Neue', 'Microsoft Yahei', Arial, sans-serif;
    font-weight: bold;
    animation: bounce infinite 2s alternate ease-in-out;
    position: relative;
  }
}

  @keyframes bounce {
    from {
      transform: translateY(0);

    }
    to {
      transform: translateY(-80px);
    }
  }
</style>
